import React from 'react';
import Constants from '../Config/Config';

export const Loader = () => {
    return  <div className="spinner">
                <div className="bounce1"></div>
                <div className="bounce2"></div>
                <div className="bounce3"></div>
            </div>;
}

export const ErrorHandle = (props) => {
	const {errorText, error} = props;
	if(error){
	  return (
	    <div className="alert alert-danger">{errorText}</div>
	  );
	}
	return (null);
}

export function roundToTwo(num) {
    return +(Math.round(num + "e+2")  + "e-2");
}

export const OVERSIZE_GLASS_MESSAGE =
    'Unfortunately the Picture Frame size you have selected requires you to select either Perspex Glass or Non-Glare Perspex Glass. We highly recommend Perspex for this Picture Frame size, as it is much lighter than Standard Glass and is much safer, as Perspex will not break. If you have any questions please contact us today!';

export function isPerspexGlass(glassID, glasses) {
    const id = parseFloat(glassID);
    if (id === 364 || id === 362) {
        return true;
    }
    if (!glasses || glasses.size === 0) {
        return false;
    }
    const glass = glasses.find((g) => parseFloat(glassID) === g.get('id'));
    if (!glass) {
        return false;
    }
    const title = (glass.getIn(['title', 'rendered']) || '').toLowerCase();
    return title.indexOf('perspex') !== -1;
}

export function getDefaultPerspexGlassId(glasses) {
    let glassID = 0;
    if (!glasses || glasses.size === 0) {
        return glassID;
    }
    glasses.filter((glass) =>
        'Perspex Glass' === glass.getIn(['title', 'rendered'])
    ).forEach((glass) => {
        glassID = glass.get('id');
    });
    return glassID;
}

export function getOversizePerspexGlassOptions(glasses) {
    const options = [];
    if (!glasses || glasses.size === 0) {
        return options;
    }
    glasses.forEach((glass) => {
        const title = glass.getIn(['title', 'rendered']) || '';
        const titleLower = title.toLowerCase();
        if (title === 'Perspex Glass') {
            options.push({ id: glass.get('id'), title });
            return;
        }
        if (
            titleLower.indexOf('perspex') !== -1 &&
            (titleLower.indexOf('non-glare') !== -1 || titleLower.indexOf('non glare') !== -1)
        ) {
            options.push({ id: glass.get('id'), title });
        }
    });
    if (options.length === 0) {
        glasses.forEach((glass) => {
            const title = glass.getIn(['title', 'rendered']) || '';
            if (title.toLowerCase().indexOf('perspex') !== -1) {
                options.push({ id: glass.get('id'), title });
            }
        });
    }
    return options;
}

export function getGlassSelectionState(glasses, glassID, matProps) {
    const {
        frameFullDimension,
        selectedMatSize,
        selectedTopMatValueInCM,
        selectedMiddleMatValueInCM,
        selectedBottomMatValueInCM,
    } = matProps;

    const state = {
        selectedGlass: glassID,
    };

    if (!glasses || glasses.size === 0) {
        return state;
    }

    const glass = glasses.find((g) => parseFloat(glassID) === g.get('id'));
    if (!glass) {
        return state;
    }

    let topMatWidth = 0;
    let middleMatWidth = 0;
    let bottomMatWidth = 0;

    if (parseFloat(selectedMatSize) !== 0) {
        topMatWidth = selectedTopMatValueInCM;
    }
    if (parseFloat(selectedMatSize) === 2 || parseFloat(selectedMatSize) === 3) {
        middleMatWidth = selectedMiddleMatValueInCM;
    }
    if (parseFloat(selectedMatSize) === 3) {
        bottomMatWidth = selectedBottomMatValueInCM;
    }

    state.glassTotal = (
        parseFloat(glass.getIn(['acf', 'price'])) *
        (frameFullDimension +
            (parseFloat(topMatWidth) * 4 +
                parseFloat(middleMatWidth) * 4 +
                parseFloat(bottomMatWidth) * 4))
    ).toFixed(2);
    state.selectedGlassName = glass.getIn(['title', 'rendered']);

    return state;
}

export function checkFramedSize(framedCalc, frameImageWidth, frameImageHeight, glassID, glasses) {
    if (framedCalc.size === 0) {
        return false;
    }

    const imageWidth = parseFloat(frameImageWidth);
    const imageHeight = parseFloat(frameImageHeight);
    const maxImageCm = Constants.MAX_STANDARD_GLASS_IMAGE_CM;

    if (imageWidth > maxImageCm || imageHeight > maxImageCm) {
        return !isPerspexGlass(glassID, glasses);
    }

    return false;
}